module.exports = __webpack_public_path__ + "static/media/solverde.3f05009b.webp";